import { Stack } from '@mui/material';
import { styled } from '~/themes';

export const StyledPlanItemContainer = styled(Stack)(({ theme }) => ({
  border: '1px solid #E2E7F0',
  borderRadius: '8px',
  background: theme.color.white,
  height: 'fit-content',
  padding: theme.spacing(2.4),
}));

export const StyledPlanContainer = styled(Stack)(() => ({
  maxWidth: 900,
  width: '100%',
  height: 'fit-content',
}));

export const StyledSubscriptionContainer = styled(Stack)(({ theme }) => ({
  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
}));
